import { Input as AntdInput } from "antd/es";
import React, { forwardRef } from "react";

// TODO allow Input accept default InputHTMLAttributes
export interface InputProps {
	autoFocus?: boolean;
	className?: string;
	disabled?: boolean;
	readOnly?: boolean;
	id?: string;
	name?: string;
	allowClear?: boolean;
	prefix?: React.ReactNode;
	style?: React.CSSProperties;
	placeholder?: string;
	value?: any;
	onChange?: (value: string) => void;
	onCancel?: () => void;
	onClick?: React.MouseEventHandler<any>;
	onConfirm?: (value: string) => void;
	onFocus?: () => void;
	onBlur?: () => void;
	onMouseEnter?: React.MouseEventHandler<any>;
	onMouseLeave?: React.MouseEventHandler<any>;
	suffix?: React.ReactNode;
	type?: string;
	maxLength?: number;
	min?: string;
}

export type InputRef = React.ComponentRef<typeof AntdInput>;

export const Input = forwardRef<InputRef, InputProps>(
	(
		{
			allowClear,
			autoFocus,
			className,
			disabled,
			id,
			maxLength,
			min,
			name,
			onBlur,
			onCancel,
			onChange,
			onClick,
			onConfirm,
			onFocus,
			onMouseEnter,
			onMouseLeave,
			placeholder,
			prefix,
			readOnly,
			style,
			suffix,
			type,
			value,
			...restProps
		},
		ref,
	) => (
		<AntdInput
			allowClear={allowClear}
			autoFocus={autoFocus}
			className={className}
			disabled={disabled}
			id={id}
			maxLength={maxLength}
			min={min}
			name={name}
			onBlur={onBlur}
			onChange={({ target }) => onChange?.(target.value)}
			onClick={onClick}
			onFocus={onFocus}
			onKeyUp={(e) => e.keyCode === 27 && onCancel?.()}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onPressEnter={() => onConfirm?.(value as string)}
			placeholder={placeholder}
			prefix={prefix}
			readOnly={readOnly}
			ref={ref}
			style={style}
			suffix={suffix}
			type={type}
			value={value}
			{...restProps}
		/>
	),
);
